import { WbacService } from '@cinch/oxd-utils/requests/src'
import { StorageKeys } from '@cinch/oxd-utils/storage/src'
import * as Storage from '@cinch/oxd-utils/storage/src'
import React from 'react'

import SEO from '../../../../../apps/www/src/components/seo'
import Steps from '../../components/steps'
import VehiclePanel from '../../components/vehicle-panel/vehicle-panel.component'
import WbacWrapper from '../../components/wrapper/wrapper.component'

import { VehicleInformation, VehicleLabelValueListsItemItem } from '../../types'

import * as styles from './vehicle-confirm.module.css'

const formatLabelValues = (items: VehicleLabelValueListsItemItem[]) =>
  items.filter((item) => !!item.sortOrder).sort((a, b) => a.sortOrder! - b.sortOrder!)

const VehicleConfirm: React.FC<any> = ({ location, navigate, i18n, path }) => {
  if (!location.state || !location.state.vehicleInformation) {
    setTimeout(() => navigate('/sell'))

    return null
  }

  const vehicleInformation: VehicleInformation = location.state.vehicleInformation

  const action = (vehicle: VehicleLabelValueListsItemItem[]) => {
    const getValueByLabel = (label: string): string => vehicle.find((v) => v && v.label === label)!.value

    const date = getValueByLabel('First Registered')
    const [day, month, year] = date.split('/')

    const formData = {
      colour: getValueByLabel('Colour'),
      guideBookVehicleCode: getValueByLabel('GuideBookCode'),
      journeyName: 'StandardQuote',
      journeyVariant: 'A',
      firstRegisteredDate: new Date(+year, +month, +day, 0, 0, 0, 0).toISOString(),
      regLetter: `${getValueByLabel('Year')}/${getValueByLabel('RegLetter')}`,
      vrm: getValueByLabel('Vrm'),
    }

    const { token: storageToken } = Storage.get(StorageKeys.wbac)
    WbacService.post('/vehicles/byGuidebook', formData, { headers: { Authorization: `JWT ${storageToken}` } })
      .then(({ data }) => data)
      .then((newVehicleInformation) => {
        const options = { state: { vehicleInformation: newVehicleInformation } }

        navigate('/sell/details', options)
      })
  }

  return (
    <>
      <SEO noIndex={true} />
      <WbacWrapper>
        <Steps page={path} />
        <ul className={styles.list}>
          {vehicleInformation.vehicleLabelValueLists.map((vehicle, index) => {
            const labels = formatLabelValues(vehicle)
            const imageItem = vehicle.find((item) => item.label === 'ImageUrl')
            const vrm = vehicle.find((item) => item.label === 'Vrm')

            return (
              <li className={styles.item} key={index}>
                <VehiclePanel
                  action={{ method: () => action(vehicle), label: i18n.panelTitle }}
                  title={vrm && vrm.value}
                  imageItem={imageItem}
                  labels={labels}
                />
              </li>
            )
          })}
        </ul>
      </WbacWrapper>
    </>
  )
}

export default VehicleConfirm
